const UiLimitPagination = () => import('./UiLimitPagination')
const UiShowMorePagination = () => import('./UiShowMorePagination')

export default function installComponents(Vue) {
  Vue.component('UiLimitPagination', UiLimitPagination)
  Vue.component('UiShowMorePagination', UiShowMorePagination)
}
